/**
 * Likőr íz_gyümölcs
 */
export type LiqueurFruitFlavor =
  | 'BLACK_CURRANT'
  | 'CHERRY_SOUR_CHERRY'
  | 'RASPBERRY'
  | 'WOOD_STRAWBERRY'
  | 'BLUEBERRIES'
  | 'CITRUS_FRUITS'
  | 'DWARF_RASPBERRY'
  | 'ARCTIC_BLACKBERRY'
  | 'CRANBERRY'
  | 'RED_CRANBERRY'
  | 'SILVER_THORN'
  | 'PINEAPPLE'
  | 'RED_GRAPES'
  | 'GRAPE'
  | 'BERRY'
  | 'STRAWBERRY'
  | 'BLACK_BLACKBERRY'
  | 'BLACKBERRY'
  | 'APPLE'
  | 'GREEN_APPLE'
  | 'PEACH0'
  | 'APRICOT'
  | 'PEACH'
  | 'PEAR'
  | 'TROPICAL_FRUITS'
  | 'MANGO'
  | 'GRENADINE'
  | 'KIWI'
  | 'LYCHEE'
  | 'PASSION_FRUIT'
  | 'POMEGRANATE'
  | 'WATERMELON'
  | 'CANTALOUPE'
  | 'OTHER';

export const LiqueurFruitFlavor = {
  BlackCurrant: 'BLACK_CURRANT' as LiqueurFruitFlavor,
  CherrySourCherry: 'CHERRY_SOUR_CHERRY' as LiqueurFruitFlavor,
  Raspberry: 'RASPBERRY' as LiqueurFruitFlavor,
  WoodStrawberry: 'WOOD_STRAWBERRY' as LiqueurFruitFlavor,
  Blueberries: 'BLUEBERRIES' as LiqueurFruitFlavor,
  CitrusFruits: 'CITRUS_FRUITS' as LiqueurFruitFlavor,
  DwarfRaspberry: 'DWARF_RASPBERRY' as LiqueurFruitFlavor,
  ArcticBlackberry: 'ARCTIC_BLACKBERRY' as LiqueurFruitFlavor,
  Cranberry: 'CRANBERRY' as LiqueurFruitFlavor,
  RedCranberry: 'RED_CRANBERRY' as LiqueurFruitFlavor,
  SilverThorn: 'SILVER_THORN' as LiqueurFruitFlavor,
  Pineapple: 'PINEAPPLE' as LiqueurFruitFlavor,
  RedGrapes: 'RED_GRAPES' as LiqueurFruitFlavor,
  Grape: 'GRAPE' as LiqueurFruitFlavor,
  Berry: 'BERRY' as LiqueurFruitFlavor,
  Strawberry: 'STRAWBERRY' as LiqueurFruitFlavor,
  BlackBlackberry: 'BLACK_BLACKBERRY' as LiqueurFruitFlavor,
  Blackberry: 'BLACKBERRY' as LiqueurFruitFlavor,
  Apple: 'APPLE' as LiqueurFruitFlavor,
  GreenApple: 'GREEN_APPLE' as LiqueurFruitFlavor,
  Peach0: 'PEACH0' as LiqueurFruitFlavor,
  Apricot: 'APRICOT' as LiqueurFruitFlavor,
  Peach: 'PEACH' as LiqueurFruitFlavor,
  Pear: 'PEAR' as LiqueurFruitFlavor,
  TropicalFruits: 'TROPICAL_FRUITS' as LiqueurFruitFlavor,
  Mango: 'MANGO' as LiqueurFruitFlavor,
  Grenadine: 'GRENADINE' as LiqueurFruitFlavor,
  Kiwi: 'KIWI' as LiqueurFruitFlavor,
  Lychee: 'LYCHEE' as LiqueurFruitFlavor,
  PassionFruit: 'PASSION_FRUIT' as LiqueurFruitFlavor,
  Pomegranate: 'POMEGRANATE' as LiqueurFruitFlavor,
  Watermelon: 'WATERMELON' as LiqueurFruitFlavor,
  Cantaloupe: 'CANTALOUPE' as LiqueurFruitFlavor,
  Other: 'OTHER' as LiqueurFruitFlavor,
};
